import { faClock } from '@fortawesome/free-solid-svg-icons/faClock';
import { FieldLabelIconMui5 } from 'components/atoms/FieldLabelIcon';
import Switch, { SwitchButtonItem } from 'components/molecules/Switch';
import { UppercaseMui5 } from '../components';
import {
  SetFilterValue,
  useFilters,
} from '../../../../../services/filters/hooks/useFilters';
import { MouseEvent } from 'react';

export const AuctionStatusFilter = ({
  setFilterValue,
  disabled = false,
}: {
  setFilterValue: SetFilterValue;
  disabled?: boolean;
}) => {
  const { filters } = useFilters();

  return (
    <Switch
      title={
        (
          <UppercaseMui5>
            <FieldLabelIconMui5 icon={faClock} color='primary' />
            Auction Status
          </UppercaseMui5>
        ) as any
      }
      value={filters.completed}
      onChange={(e: MouseEvent<HTMLElement>, completed: boolean) => {
        if (completed == null || disabled) {
          return;
        }

        setFilterValue('completed', completed);
      }}
      size='small'
      items={
        [
          { value: false, label: 'Active' },
          { value: true, label: 'Completed' },
        ] as SwitchButtonItem[]
      }
      aria-label='text formatting'
    />
  );
};
